export const VNTAXES_FETCH_TAXES_SUCCEEDED = 'VNTAXES_FETCH_TAXES_SUCCEEDED'
